import { render, staticRenderFns } from "./Assembly.vue?vue&type=template&id=a42262c6&scoped=true"
import script from "./Assembly.vue?vue&type=script&lang=ts"
export * from "./Assembly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42262c6",
  null
  
)

export default component.exports